import { useContext } from "react";
import PropTypes from "prop-types";

/**
 * contexts
 */
import context from "./context";
import contextItem from "./context-item";
import { AccordionContext } from "common/contexts";

/** ========== */

const Component = ({ eventKey, children, ...props }) => {
  const { active } = useContext(AccordionContext);
  const open = active?.includes(eventKey);
  return (
    <contextItem.Provider value={{ eventKey, open }}>
      <div {...props}>{children({ open })}</div>
    </contextItem.Provider>
  );
};

export default Component;

Component.propTypes = {
  eventKey: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

/** ========== */
